import styled from "styled-components";

const BlogHomeStyles = {
    Container: styled.div`
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    `,

    ContentContainer: styled.div`
        width: 80%;
        height: 90%;
        max-width: 1400px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        align-items: center;
        gap: 50px;
        margin-bottom: 75px;
    `,

    TitleContainer: styled.div`
        width: 100%;
        display: flex;
        justify-content: flex-start;
    `,

    TitleBoxContainer: styled.div`
        width: 200px;
        height: 100px;
        border-bottom: 1px solid gray;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    `,

    TitleBox: styled.div`
        width: 170px;
        height: 30px;
        text-align: center;
        border-left: 1px solid gray;
        border-right: 1px solid gray;
    `,

    TitleText: styled.div`
        font-family: "Barcade";
        font-size: 1.8rem;
        position: relative;
        bottom: 10px;
    `,

    SubTitleText: styled.div`
        font-size: 1.4rem;
        display: flex;
        align-items: flex-start;
        width: 100%;
    `,

    BlogPostsGrid: styled.div`
        display: grid;
        justify-content: space-between;
        width: 100%;
        column-gap: 5%;
        row-gap: 60px;
        grid-template-columns: 1fr 1fr;
        @media (max-width: 1030px) {
            grid-template-columns: 1fr;
        }
    `,
};

export default BlogHomeStyles;
